var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "p",
        {
          directives: [{ name: "copy-text", rawName: "v-copy-text" }],
          staticClass: "link-txt",
          on: {
            click: function ($event) {
              _vm.dialog.visible = true
            },
          },
        },
        [_vm._v(_vm._s(_vm.rowData[_vm.fieldData.fieldCode]))]
      ),
      _vm._v(" "),
      _c(
        "OPZDialog",
        {
          attrs: {
            title: _vm.dialog.title,
            width: _vm.dialog.width,
            visible: _vm.dialog.visible,
            "is-footer": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.visible
            ? _c("OPZTable", {
                attrs: {
                  height: "500",
                  columns: _vm.dialog.columns,
                  "request-method": _vm.getGetReturnDetailOrPackDetail,
                  "request-params": _vm.dialog.params,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }